// Platform-admin hooks over the internal usage metrics (spec 2026-10-01-02):
// GET /api/v1/admin/usage/users and /users/{userUid}/sessions. Cross-org and
// server-wide, never visible to organizations.
import { $api } from '../api/queryClient'
import type { components } from '../api/schema'

export type AdminUsageUser = components['schemas']['AdminUsageUser']
export type AdminUsageUserList = components['schemas']['AdminUsageUserList']
export type AdminUsageSession = components['schemas']['AdminUsageSession']
export type AdminUsageUserSessions = components['schemas']['AdminUsageUserSessions']
export type AdminUsageAlert = components['schemas']['AdminUsageAlert']

export type UsagePeriod = 'day' | 'month'

export interface UsageListQuery {
    period: UsagePeriod
    date?: string
    org?: string
    sort?: string
}

/** useAdminUsageUsers loads one row per user and organization for the period. */
export function useAdminUsageUsers(query: UsageListQuery) {
    return $api.useQuery('get', '/api/v1/admin/usage/users', {
        params: {
            query: {
                period: query.period,
                date: query.date || undefined,
                org: query.org || undefined,
                sort: query.sort || undefined,
                limit: 1000,
            },
        },
    })
}

/**
 * useAdminUsageUserSessions loads a user's sessions and their hourly timeline
 * over [from, to). Disabled until a user is selected.
 */
export function useAdminUsageUserSessions(userUid: string | undefined, from?: string, to?: string) {
    return $api.useQuery(
        'get',
        '/api/v1/admin/usage/users/{userUid}/sessions',
        {
            params: {
                path: { userUid: userUid ?? '' },
                query: { from: from || undefined, to: to || undefined },
            },
        },
        { enabled: !!userUid },
    )
}
